/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import React, { useState, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { v4 as uuidv4 } from 'uuid';
import metaMask from '../../assets/images/nft/newrecord.png';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Input,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { api } from '../../config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const OverviewTab = ({ ids, form, token, setIsLoading }) => {
  const navigate = useNavigate();
  const { user } = useSelector(state => state.Login);
  const [Overview, setOverview] = useState({});
  const toBool = val => val === true || val === 'true';

  const handleTextChange = field => event => {
    setOverview({
      ...Overview,
      [field]: event.target.value,
    });
  };

  const toggledeletemodal = () => {
    setDeleteModal(!deletemodal);
  };

  const togglemodal = () => {
    setModal(!modal);
  };

  const [modal_togFirst, setmodal_togFirst] = useState(false);
  function tog_togFirst() {
    setmodal_togFirst(!modal_togFirst);
  }
  const [modal_togSecond, setmodal_togSecond] = useState(false);
  function tog_togSecond() {
    setmodal_togSecond(!modal_togSecond);
  }
  const sigCanvas = useRef(null);
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');

  const clear = () => {
    sigCanvas.current.clear();
    setMessage('');
  };

  const handleAddOverviewSubmit = async ids => {
    try {
      // const save = () =>

      const trimmedCanvas = sigCanvas.current.getCanvas();
      //setImageURL(trimmedCanvas.toDataURL("image/png"));
      const dataURL = trimmedCanvas.toDataURL('image/png');
      const blob = await (await fetch(dataURL)).blob();
      const uniqueId = uuidv4();
      //const fileName = `signature-${uniqueId}.png`;
      const fileName = `signature.png`;
      //const formData = new FormData();

      // lalu convert ke base64
      //const dataURL = trimmedCanvas.toDataURL("image/png");
      //setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
      //const clear = () => sigCanvas.current.clear();
      //      setImageURL(trimmedCanvas.toDataURL("image/png"));
      if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
        toast.error('Silakan tanda tangan terlebih dahulu');
        return;
      }
      // setIsLoading && setIsLoading(true);
      // const rawCanvas =
      //   typeof sigCanvas.current.getCanvas === "function"
      //     ? sigCanvas.current.getCanvas()
      //     : null;

      // if (!rawCanvas) {
      //   toast.error("Tidak dapat mengakses canvas tanda tangan.");
      //   setIsLoading && setIsLoading(false);
      //   return;
      // }
      // const trimmed = cropCanvas(rawCanvas);
      // const dataURL = trimmed.toDataURL("image/png");
      // const blob = await (await fetch(dataURL)).blob();
      // const uniqueId = uuidv4();
      // const fileName = `signature-${uniqueId}.png`;
      //const formData = new FormData();

      //------------------------------
      // const formData = new FormData();
      // setOverview({
      //   FullName: "imam",
      //   Position: "staff",
      //   Division: "-",
      //   Signature: "-",
      // });

      // formData.append("ProcurementId", ids);
      // formData.append("FullName", Overview?.FullName || "imam");
      // formData.append("Position", Overview?.FullName || "staff");
      // formData.append("Division", Overview?.Division || "-");
      // formData.append("Signature", Overview?.Division || "-");
      // formData.append("FileSignatureSpecimen", blob, fileName);

      // const response = await axios.post(
      //   `${api.API_URL}/digital-signature`,
      //   formData,
      //   {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );

      //----------------------------

      // Jika mau hardcode sebelum submit
      const newOverview = {
        FullName: user.username,
        Position: null,
        Division: null,
        Signature: '-', // default sebelum tanda tangan
      };

      // Update state
      setOverview(newOverview);

      // Buat FormData
      const formData = new FormData();
      formData.append('ProcurementId', form.id);
      //formData.append('FullName', newOverview.FullName || null);
      //formData.append('Position', newOverview.Position || null);
      //formData.append('Division', newOverview.Division || null);
      //formData.append('Signature', newOverview.Signature || '-');
      formData.append('FileSignatureSpecimen', blob, fileName);

      const response = await axios.post(
        `${api.API_URL}/digital-signature`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        title: 'Submission Successful',
        text: 'The planning & procurement from has been successfully submitted for final validation. You will be notified once the process is complete',
        icon: 'success',
      });

      //setmodal_togSecond(false);
      navigate(`/apps-procurement/view`);
    } catch (err) {
      console.error('handleAddOverviewSubmit error:', err);
    } finally {
      setIsLoading && setIsLoading(false);
    }
  };

  const modalWidth = '415px';

  const overviewSteps = [
    {
      no: 1,
      title: 'Procurement Requirement',
      done: toBool(form.isProcurementRequirementCompleted),
      icon: 'ri-file-list-3-line',
    },
    {
      no: 2,
      title: 'Supporting Document',
      done: toBool(form.isSupportingDocumentsCompleted),
      icon: 'ri-file-text-line',
    },
    {
      no: 3,
      title: 'DMUT Invitation',
      done: toBool(form.isDMUTInvitationCompleted),
      icon: 'ri-mail-send-line',
    },
  ];
  const allStepsDone = overviewSteps.every(s => s.done);

  return (
    <React.Fragment>
      <Row>
        <div>
          <Row>
            <Col sm={12}>
              <div color='dark' className='d-flex align-items-center mb-2  '>
                <div className='flex-grow-1'>
                  <h5 className='mb-1'>
                    <i className='ri-checkbox-circle-line me-2'></i>
                    Procurement Process Overview
                  </h5>
                  <p className='text-muted mb-2 fs-12 '>
                    Review the completion status of each step, then submit the
                    process for final validation.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div>
          <Row>
            <Col lg={12}>
              <div className={`ov-banner ${allStepsDone ? 'done' : 'pending'}`}>
                <i
                  className={
                    allStepsDone ? 'ri-checkbox-circle-fill' : 'ri-time-line'
                  }
                ></i>
                <div>
                  <h6 className='mb-1 fw-semibold'>
                    {allStepsDone ? 'All Steps Completed' : 'Steps Remaining'}
                  </h6>
                  <p className='mb-0 text-muted'>
                    {allStepsDone
                      ? 'All required procurement steps have been successfully completed. You may now submit the process for final validation.'
                      : 'Complete every step below before submitting the process for final validation.'}
                  </p>
                </div>
              </div>
            </Col>

            <Col lg={12}>
              <Row className='g-3 mt-1'>
                {overviewSteps.map(step => (
                  <Col md={4} key={step.no}>
                    <div className={`ov-step ${step.done ? 'done' : ''}`}>
                      <div className='ov-step-icon'>
                        <i className={step.icon}></i>
                      </div>
                      <div className='flex-grow-1'>
                        <div className='ov-step-no'>STEP {step.no}</div>
                        <h6 className='mb-2'>{step.title}</h6>
                        <span
                          className={`badge ${
                            step.done
                              ? 'bg-success-subtle text-success'
                              : 'bg-warning-subtle text-warning'
                          }`}
                        >
                          {step.done ? 'Completed' : 'On Progress'}
                        </span>
                      </div>
                      {step.done && (
                        <i className='ri-check-double-line ov-step-check'></i>
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>

        <div className='d-flex align-items-start gap-3 mt-4'>
          {form.isProcurementCompleted === false && (
            <>
              {toBool(form.isSupportingDocumentsCompleted) &&
                toBool(form.isProcurementRequirementCompleted) &&
                toBool(form.isDMUTInvitationCompleted) && (
                  <button
                    type='button'
                    className='btn btn-primary btn-label right ms-auto nexttab'
                    onClick={() => tog_togFirst()}
                  >
                    <i className='ri-checkbox-circle-line label-icon align-middle fs-16 ms-2'></i>
                    Submit to Final Validation
                  </button>
                )}
            </>
          )}
        </div>
      </Row>

      <Modal
        isOpen={modal_togFirst}
        toggle={() => {
          tog_togFirst();
        }}
        id='firstmodal'
        centered
      >
        <ModalHeader
          toggle={() => {
            setmodal_togFirst(false);
          }}
        ></ModalHeader>
        <ModalBody className='text-center p-5'>
          <div className='mt-1 pt-2'>
            <Row className='justify-content-center mb-1'>
              <Col lg={12} className='text-center'>
                <img src={metaMask} alt='' height='65' className='mb-2 pb-2' />
                <h5>Confirm Final Submission</h5>
                <p className='text-muted pb-1'>
                  Are you sure you want to submit this planning & procurement
                  process for final validation? This action cannot be undone
                </p>
              </Col>
            </Row>
            <Button
              className='btn btn-primary'
              onClick={() => {
                tog_togSecond();
                tog_togFirst(false);
              }}
            >
              Yes, Next
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={modal_togSecond}
        toggle={() => {
          setmodal_togSecond();
        }}
        id='secondmodal'
        centered
        style={{ maxWidth: modalWidth }}
        className='custom-modal-width'
      >
        <ModalHeader
          toggle={() => {
            setmodal_togSecond(false);
          }}
        ></ModalHeader>
        <ModalBody>
          <Col sm={12}>
            <Row>
              <Row className='justify-content-center mb-1'>
                <Col lg={12} className='text-center'>
                  <img
                    src={metaMask}
                    alt=''
                    height='65'
                    className='mb-3 pb-2'
                  />
                  <h5>Digital Signature Confirmation</h5>
                </Col>
              </Row>

              <Col lg={12}>
                <div className='mb-2 bor border-top  border-top-dashed '></div>
              </Col>

              <Col sm={12}>
                <div className='mb-2 mt-2'>
                  <Label for='FullName' className='form-label fw-semibold '>
                    Full Name:
                  </Label>
                  <Input
                    type='text'
                    id='FullName'
                    name='FullName'
                    value={user.username}
                    className='form-control'
                    onChange={e => {
                      handleTextChange(e);
                    }}
                    disabled={true}
                  />
                </div>
              </Col>
              <Col sm={12}>
                <div className='mb-2'>
                  <Label for='Position' className='form-label fw-semibold '>
                    Position:
                  </Label>
                  <Input
                    type='text'
                    id='Position'
                    name='Position'
                    value={user.position}
                    className='form-control'
                    onChange={e => {
                      handleTextChange(e);
                    }}
                    disabled={true}
                  />
                </div>
              </Col>
              <Col sm={12}>
                <div className='mb-2'>
                  <Label for='Division' className='form-label fw-semibold '>
                    Division:
                  </Label>
                  <Input
                    type='text'
                    id='Division'
                    name='Division'
                    value={user.division}
                    className='form-control'
                    onChange={e => {
                      handleTextChange(e);
                    }}
                    disabled={true}
                  />
                </div>
              </Col>

              <Col sm={12}>
                <div className='mb-2'>
                  <Label for='deliveryUnit' className='form-label fw-semibold '>
                    Signature:
                  </Label>
                </div>
              </Col>
              <Col sm={12}>
                <div style={{ maxWidth: '100%' }}>
                  <SignatureCanvas
                    ref={sigCanvas}
                    penColor='black'
                    canvasProps={{
                      width: 370,
                      height: 200,
                      className: 'sigCanvas',
                      style: { border: '1px solid #5555' },
                    }}
                  />
                </div>
              </Col>

              {/* {imageURL ? (
                <img
                  src={imageURL}
                  alt="my signature"
                  style={{
                    display: "block",
                    margin: "0 auto",
                    border: "1px solid black",
                    width: "150px",
                  }}
                />
              ) : null} */}
            </Row>
          </Col>
        </ModalBody>

        <ModalFooter className='text-center '>
          <Button
            type='button'
            className='btn btn-primary btn-label right  nexttab'
            onClick={() => {
              setmodal_togSecond(false);
            }}
          >
            <i className=' ri-logout-box-r-line label-icon align-middle fs-16 ms-2'></i>
            Cancel
          </Button>

          <Button
            type='button'
            className='btn btn-primary btn-label right  nexttab'
            onClick={() => {
              handleAddOverviewSubmit({ ids });
            }}
          >
            <i className=' ri-database-2-line label-icon align-middle fs-16 ms-2'></i>
            Confirm & Submit
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default OverviewTab;
